module.exports = __webpack_public_path__ + "static/Waiting-Room_feature-f4afb31648152b62e1a1b11303eaca6d.webp";